export default __webpack_public_path__ + "static/media/hdd.6ad4c346.svg";